import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { logout } from '../api/auth';
import '../styles/Navbar.css';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isUserDropdownOpen, setIsUserDropdownOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const dropdownRef = useRef(null);
  const isActivePath = (paths) => paths.includes(location.pathname);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleUserDropdown = () => {
    setIsUserDropdownOpen(!isUserDropdownOpen);
  };

  const handleLogout = () => {
    logout();
    setIsUserDropdownOpen(false);
    navigate('/login');
  };

  const handleSettingsClick = () => {
    setIsUserDropdownOpen(false);
    navigate('/settings');
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsUserDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <nav className="navbar">
      <div className="mobile-app-header">
        <Link to="/dashboard" className="mobile-app-brand">
          <span className="mobile-app-emoji">📦</span>
          <span className="mobile-app-title">Order Dashboard</span>
        </Link>
        <button
          type="button"
          className="mobile-app-settings-btn"
          onClick={handleSettingsClick}
          aria-label="Open settings"
        >
          ⚙️
        </button>
      </div>
      <div className="navbar-container">
        {/* Logo */}
        <div className="navbar-logo">
          <Link to="/dashboard" className="logo-link">
            <h2>📦 Order Dashboard</h2>
          </Link>
        </div>

        {/* Desktop Navigation */}
        <div className={`navbar-menu ${isMenuOpen ? 'active' : ''}`}>
          <div className="navbar-nav">
            <Link to="/dashboard" className={`nav-link${isActivePath(['/dashboard']) ? ' active' : ''}`}>
              <span className="nav-icon">📊</span>
              Orders
            </Link>
            <Link to="/tracking" className={`nav-link${isActivePath(['/tracking']) ? ' active' : ''}`}>
              <span className="nav-icon">🚚</span>
              Tracking
            </Link>
            <Link to="/products" className={`nav-link${isActivePath(['/products']) ? ' active' : ''}`}>
              <span className="nav-icon">🛍️</span>
              Products
            </Link>
            <Link
              to="/sales"
              className={`nav-link${isActivePath(['/sales']) ? ' active' : ''}`}
            >
              <span className="nav-icon">📚</span>
              Book sales
            </Link>
            <Link
              to="/inventory"
              className={`nav-link${isActivePath(['/inventory']) ? ' active' : ''}`}
            >
              <span className="nav-icon">📦</span>
              Inventory
            </Link>
            <Link
              to="/settings"
              className={`nav-link mobile-settings-link${isActivePath(['/settings']) ? ' active' : ''}`}
            >
              <span className="nav-icon">⚙️</span>
              Settings
            </Link>
          </div>

          {/* User Actions */}
          <div className="navbar-actions">
            <div className="user-dropdown" ref={dropdownRef}>
              <button 
                onClick={toggleUserDropdown} 
                className="btn btn-outline user-dropdown-toggle"
                aria-expanded={isUserDropdownOpen}
              >
                <span className="nav-icon">👤</span>
                Account
                <span className={`dropdown-arrow ${isUserDropdownOpen ? 'open' : ''}`}>▼</span>
              </button>
              
              {isUserDropdownOpen && (
                <div className="user-dropdown-menu">
                  <button 
                    onClick={handleSettingsClick} 
                    className="dropdown-item"
                  >
                    <span className="dropdown-icon">⚙️</span>
                    Settings
                  </button>
                  <div className="dropdown-divider"></div>
                  <button 
                    onClick={handleLogout} 
                    className="dropdown-item logout-item"
                  >
                    <span className="dropdown-icon">🚪</span>
              Logout
            </button>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Mobile Menu Toggle */}
        <button 
          className={`navbar-toggle ${isMenuOpen ? 'active' : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle navigation"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </nav>
  );
};

export default Navbar; 